import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { ShieldCheck, Send, Newspaper, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    icon: ShieldCheck,
    name: "Guaranteed Placements",
    path: "/services/guaranteed-placements",
    role: "Anchor the first page",
    desc: "Named, high-authority publications you choose — so your own coverage dominates page one for your name and brand.",
  },
  {
    icon: Newspaper,
    name: "Newswire Distribution",
    path: "/services/newswire-distribution",
    role: "Build the reference layer",
    desc: "Broad syndication that generates the corroborating mentions Google and AI search look for when building an entity.",
  },
  {
    icon: Send,
    name: "Journalist Outreach",
    path: "/services/journalist-outreach",
    role: "Earn third-party authority",
    desc: "Earned coverage from real journalists — the independent, authoritative sources that move the needle on reputation.",
  },
];

export default function ReputationServices() {
  return (
    <section className="py-7 sm:py-9 lg:py-12 bg-canvas">
      <Container>
        <div className="text-center mb-12 lg:mb-16">
          <span className="meta-tag inline-block mb-4">HOW WE DEPLOY D24</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-bone leading-tight mb-4">
            Every Digital24 service, pointed at your reputation.
          </h2>
          <p className="text-steel text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
            We don't run generic campaigns. Each service is tailored around your personal and brand keywords to own the results that matter.
          </p>
        </div>
        <div className="grid lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <div key={s.name} className="bg-white border border-[#e8e6ef] rounded-xl p-8 flex flex-col">
              <div className="w-11 h-11 rounded-lg bg-cobalt/10 flex items-center justify-center mb-5">
                <s.icon className="w-5 h-5 text-cobalt" />
              </div>
              <span className="font-mono text-xs uppercase tracking-widest text-cobalt mb-2">{s.role}</span>
              <h3 className="font-heading text-lg font-semibold text-bone mb-3">{s.name}</h3>
              <p className="text-sm text-steel leading-relaxed mb-6 flex-1">{s.desc}</p>
              <Link to={s.path} className="inline-flex items-center gap-1.5 text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors">
                Explore the service <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}